<div class="modal-header">
  <h4 [innerHTML]="modalTitle" class="modal-title h5"></h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

  <scitis-select-machines-dropdown
      [organizationId]="organizationId"
      (selectedMachineIds)="onUpdateSelectedMachines($event)">
  </scitis-select-machines-dropdown>

  <div class="form-group">
    <div class="custom-control custom-switch mx-2">
      <input (change)="onSetAsSharedChanged()" class="custom-control-input" [disabled]="!isAdminOrHigher" id="setAsShared"
             type="checkbox" [checked]="setAsShared">
      <label class="custom-control-label" for="setAsShared" translate>Set target page(s) as shared</label>
    </div>
  </div>

  <div class="form-group">
    <div class="alert alert-info text-left">
      <ul>
        <li><span translate>The menu update might take some time.</span></li>
        <li><span translate>Review new page settings after copy process completes</span></li>
      </ul>
    </div>
  </div>

</div>

<scitis-modal-footer (cancelButtonPressed)="onCancel()"
                     (okButtonPressed)="onCopyPage()"
                     [cancelButtonText]="'Cancel'|translate"
                     [okButtonText]="'Copy'|translate"
                     [showRequiredFieldsIndicator]="false">

</scitis-modal-footer>